import { navigateToChangeImpactReports } from '../../../links/index.jsx';

export const resetQuery = {
  title: null,
  // startDate: null,
  // endDate: null,
  peopleImpacted: null,
  changeImpactTypeIds: [],
  scale: [],
  perceptions: [],
  ownerIds: [],
  impactedEmployeesIds: [],
  impactedGroupsIds: [],
  impactedExternalEntitiesIds: [],
  actionPlanTypes: [],
  actionPlanStatuses: [],
  externalEntities: [],
  organizationStakeholderIds: [],
  taskIds: [],
  taskStatuses: [],
  taskOwnerIds: [],
  projectsIds: [],
  parentPortfolioIds: [],
  portfolioIds: [],
  stakeholderInfluences: [],
  stakeholderInterests: [],
  stakeholderImpacts: [],
  stakeholderEngagementFrequencies: [],
  stakeholderSupports: [],
};
export const resetFilters = (preselectedFilters) => {
  const query = { ...resetQuery, preselectedFilters };

  navigateToChangeImpactReports(query);
};
